import React from "react";
import { PulseLoaderProps } from "./types";

const PulseLoader: React.FC<PulseLoaderProps> = ({
  size = 8,
  primaryColor = "#1C6CFF",
  secondaryColor = "#B8B8B8",
  animationDuration = 2,
  className = "",
}) => {
  const spacing = size * 2;

  const pulseKeyframes = `
    @keyframes shadowPulse-${size} {
      0% {
        background-color: ${secondaryColor};
        box-shadow: -${spacing}px 0 0 0 ${primaryColor}, ${spacing}px 0 0 0 ${secondaryColor};
      }
      33% {
        background-color: ${primaryColor};
        box-shadow: -${spacing}px 0 0 0 ${secondaryColor}, ${spacing}px 0 0 0 ${secondaryColor};
      }
      66% {
        background-color: ${secondaryColor};
        box-shadow: -${spacing}px 0 0 0 ${secondaryColor}, ${spacing}px 0 0 0 ${primaryColor};
      }
      100% {
        background-color: ${secondaryColor};
        box-shadow: -${spacing}px 0 0 0 ${primaryColor}, ${spacing}px 0 0 0 ${secondaryColor};
      }
    }
  `;

  return (
    <div
      className={`flex justify-center items-center ${className}`}
      role="status"
      aria-label="loading"
    >
      <style>{pulseKeyframes}</style>
      <div
        className="rounded-full relative"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: secondaryColor,
          boxShadow: `-${spacing}px 0 0 0 ${primaryColor}, ${spacing}px 0 0 0 ${secondaryColor}`,
          animation: `shadowPulse-${size} ${animationDuration}s linear infinite`,
        }}
      />
    </div>
  );
};

export default PulseLoader;
